var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { Question } from 'packages/form/entities/question/Question';
import { Result } from 'packages/form/entities/Result';
import { Welcome } from 'packages/form/entities/Welcome';
import { container } from 'tsyringe';
import VueI18n from 'vue-i18n';
import ENV from 'config/env';
var PublicJobDetails = /** @class */ (function (_super) {
    __extends(PublicJobDetails, _super);
    function PublicJobDetails() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.isApplicable = null;
        _this.activeTo = null;
        return _this;
    }
    return PublicJobDetails;
}(Entity));
export { PublicJobDetails };
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.additionalQuestions = [];
        _this.isApplicationForm = null;
        // only applicable for non-application forms
        _this.expiresAt = null;
        _this.version = 2;
        _this.uuid = null;
        _this.companyId = null;
        _this.jobId = null;
        _this.name = '';
        _this.lang = 'en-GB';
        _this.jobDetails = null;
        _this.type = null;
        _this.welcome = new Welcome();
        _this.questions = [];
        _this.results = [];
        _this.createdAt = null;
        _this.updatedAt = null;
        return _this;
    }
    Object.defineProperty(Form.prototype, "liveLink", {
        get: function () {
            return ENV.APPS.FORM_VIEWER.URL + this.uuid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "previewLink", {
        get: function () {
            return this.liveLink + "?reference";
        },
        enumerable: false,
        configurable: true
    });
    Form.prototype.ensureResultScreens = function () {
        if (this.results.length) {
            return;
        }
        var i18n = container.resolve(VueI18n);
        var resultScreens = [];
        for (var i = 0; i <= 4; i++) {
            resultScreens.push({
                title: i18n.t("ats.job.application_form.results." + i + ".title", this.lang),
                description: i18n.t("ats.job.application_form.results." + i + ".description", this.lang),
                category: i,
            });
        }
        this.results = EntityBuilder.buildMany(Result, resultScreens);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Form.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        // Rename job to jobDetails because Response.ts is already using key "Job"
        this.jobDetails = EntityBuilder.buildOne(PublicJobDetails, jsonData.job);
        // This is here so that we always got an array of additional questions. Entity be broken.
        if (jsonData.additional_questions) {
            this.additionalQuestions = EntityBuilder.buildMany(Question, jsonData.additional_questions);
        }
        else {
            this.additionalQuestions = [];
        }
        return this;
    };
    Form.prototype.recalculatePositions = function (questions) {
        return questions.map(function (question, index) {
            question.position = index + 1;
            if (question.type === 'select') {
                question.options = question.options.map(function (option, index) {
                    option.position = index + 1;
                    return option;
                });
            }
            return question;
        });
    };
    /* eslint-disable @typescript-eslint/no-explicit-any */
    Form.prototype.toJson = function (toSnake, asString) {
        this.questions = this.recalculatePositions(this.questions);
        if (this.additionalQuestions.length > 0) {
            this.additionalQuestions = this.recalculatePositions(this.additionalQuestions);
        }
        return _super.prototype.toJson.call(this, toSnake, asString);
    };
    var _a;
    __decorate([
        Type(Question),
        __metadata("design:type", Array)
    ], Form.prototype, "additionalQuestions", void 0);
    __decorate([
        Type(PublicJobDetails),
        __metadata("design:type", PublicJobDetails)
    ], Form.prototype, "jobDetails", void 0);
    __decorate([
        Type(Welcome),
        __metadata("design:type", typeof (_a = typeof Welcome !== "undefined" && Welcome) === "function" ? _a : Object)
    ], Form.prototype, "welcome", void 0);
    __decorate([
        Type(Question),
        __metadata("design:type", Array)
    ], Form.prototype, "questions", void 0);
    __decorate([
        Type(Result),
        __metadata("design:type", Array)
    ], Form.prototype, "results", void 0);
    return Form;
}(Entity));
export { Form };
